import React from 'react';
import ClassroomCheckListComponent from '../../components/Filters/classroomCheckList';

class ClassroomCheckList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            value: 'Ninguna',
            checkboxes: [],
            checkAll: false,
        }
        this.setOpen = this.setOpen.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClickListItem = this.handleClickListItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleChangeAll = this.handleChangeAll.bind(this);
    }


    componentDidMount() {
        this.setInitialState();
    };

    componentDidUpdate(prevProps) {
        if (prevProps.filters !== this.props.filters) {
            this.setInitialState();
        }
    }

    /**
     * Asigna valor de checkboxes.
    */
    setInitialState(){
        const { data } = this.props;
        this.setState({ checkAll: false });
        const checkboxes = [];
        for (var i = 0; i < data.length; i++) {
            var checkboxItem = {}
            checkboxItem = {
                name: data[i].name,
                id: data[i].id,
                checked: false
            }
            checkboxes.push(checkboxItem);
        }
        this.setState({ checkboxes: checkboxes,  value: "Ninguna" })
    }

    /**
     * Abre y cierra modal de selección de tipos de salas.
     * @param {Boolean} value - Valor a asignar al estado de apertura.
    */
    setOpen(value) {
        this.setState({ open: value })
    };

    /**
     * Asigna valor booleanoa campos checkeados.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un checkbox.
    */
    handleChange(e) {
        const { checkboxes } = this.state;
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].id === e.target.id) {
                checkboxes[i].checked = e.target.checked;
            }
        }
        this.setState({ checkboxes: checkboxes });
        this.setState({checkAll:false})
    };

    /**
     * Asigna el mismo valor booleano a todos los checkbox.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre el checkbox "Todas".
    */
    handleChangeAll(e) {
        this.setState({ checkAll: e.target.checked })
        const { checkboxes } = this.state;
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = e.target.checked;
        }
        this.setState({ checkboxes: checkboxes })
    }

    /**
     * Asigna texto secundario con tipos de salas seleccionadas.
     * @param {String} e - Texto con tipos de salas seleccionadas.
    */
    setValue(value) {
        this.setState({ value: value })
    };

    /**
     * Abre modal con tipos de salas al hacer clic sobre item de tipo de salas en Filtros.
    */
    handleClickListItem() {
        this.setOpen(true);
    };

    /**
     * Cierra modal de selección de tipo de salas y asigna texto secundario con salas seleccionadas.
     * @param {String} newValue - Texto con tipos de salas seleccionadas.
    */
    handleClose(newValue) {
        this.setOpen(false);

        if (newValue) {
            this.setValue(newValue);
        }
    };

    /**
     * Crea y asigna mensaje de datos seleccionados en el filtro al hacer clic en "Ok" en el modal.
    */
    handleOk() {
        const { id, name, updateFiltersMessage } = this.props;
        const { checkboxes } = this.state;
        var parameters = '';
        var parametersArray = [];
        var checkedValues = []
        checkboxes.map(parameter => {
            if (parameter.checked) {
                parametersArray.push(
                    '<parameter>',
                    '<id>',
                    parameter.id,
                    '</id>',
                    '<name>',
                    parameter.name,
                    '</name>',
                    '</parameter>'
                )
                checkedValues.push(parameter.name)
            }
        })
        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
        updateFiltersMessage(message);
        const values = checkedValues.join(", ")
        var secondaryText = checkedValues.length === 0 ? 'Ninguna' : values;
        this.handleClose(secondaryText);
    };

    render() {
        const { open, value, checkboxes, checkAll } = this.state;
        const { required, height } = this.props;

        return (
            <ClassroomCheckListComponent
                height={height}
                open={open}
                value={value}
                required={required}
                checkAll={checkAll}
                checkboxes={checkboxes}
                handleClickListItem={this.handleClickListItem}
                handleChange={this.handleChange}
                handleOk={this.handleOk}
                handleChangeAll={this.handleChangeAll}
            />
        )
    }
}

export default ClassroomCheckList;